import { connect, useDispatch } from "react-redux";
import ReportEdit from "./reportEdit";
import { useState, useEffect, useCallback } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import {
  getReports,
  getReport,
  deleteReport,
} from "../../../../../action/masters/reportActionCreator";
import { baseURL } from "../../../../../constants/commonConstants";
import {
  alertConstants,
  getAlertData,
} from "../../../../../helper/sweet-alert";
import {
  IReport,
  IReportIndex,
  IReports,
} from "../../../../../models/master/reports";
import { setReports } from "../../../../../store/slices/master/reportSlice";
import ReportCreate from "./reportCreate";
import ReactModal from "react-modal";
import LoaderSpinner from "../../../../../common-components/loader";
import FloatingLabelDropDown from "../../../../../common-components/floatingdropdown";
import { sortAlphabetically } from "../../../../../common-functions/commonFunctions";
import { UserTypes } from "../../../../../models/dashboard/adminDashboard";
import { getUserTypes } from "../../../../../action/common/commonActionCreator";

const ReportIndex = (props: IReportIndex) => {
  const {
    getReport,
    reports,
    deleteReport,
    getReports,
    report,
    userTypes,
    getUserTypes,
  } = props;
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<number>(0);
  const [errors, setErrors] = useState<any>(undefined);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isEditLoading, setIsEditLoading] = useState<boolean>(false);
  const [selectedUserType, setSelectedUserType] = useState<number | null>(null);
  const [reportsData, setReportsData] = useState<IReports[]>([]);
  const dispatch = useDispatch();

  const handleCreateOpen = () => setShowCreate(true);
  const handleCreateClose = () => setShowCreate(false);
  const handleEditOpen = () => setShowEdit(true);
  const handleEditClose = () => setShowEdit(false);

  // useEffect(() => {
  //   setReportsData(reports)
  // }, [reports])

  const editItem = async (id: number) => {
    handleEditOpen();
    setIsEditLoading(true);
    try {
      await getReport(id);
    } finally {
      setIsEditLoading(false);
    }
  };

  useEffect(() => {
    if (typeof selectedUserType == "number") {
      setReportsData(() =>
        reports?.filter((r: IReports) => r.userType == selectedUserType)
      );
    } else {
      setReportsData(reports);
    }
  }, [selectedUserType, reports]);

  const deleteItem = (id: number) => {
    setIsDelete(true);
    setAlert(alertConstants.inactiveCheck);
    setItemToDelete(id);
  };

  const onConfirm = () => {
    if (alertType === alertConstants.error) {
      setShowAlert(false);
    } else if (isDelete === true) {
      setShowAlert(false);
      setIsDelete(false);
      deleteReport(itemToDelete, setAlert);
    } else {
      setShowAlert(false);
      setIsDelete(false);
      getAllReports();
    }
  };

  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      setShowAlert(true);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  const getAllReports = async () => {
    setIsLoading(true);
    try {
      await getReports();
    } finally {
      setIsLoading(false);
    }
  };

  const onUserTypeChange = useCallback((e: any) => {
    if (e.target.name == "userType") setSelectedUserType(e.target.value);
  }, []);

  useEffect(() => {
    getAllReports();
    getUserTypes();
    return () => {
      dispatch(setReports([]));
    };
  }, []);

  return (
    <>
      <div className="admincontent">
        <div className="title">
          <h2>Reports</h2>
          <div className="side-filter">
            <div className="justify-content-left">
              <FloatingLabelDropDown
                label=""
                placeholder="-Select UserType-"
                onChange={(e: any) => onUserTypeChange(e)}
                isMandatory={false}
                value={selectedUserType}
                name="userType"
                optionsList={sortAlphabetically(
                  userTypes?.filter(
                    (type) =>
                      type.id !== UserTypes.Freshman &&
                      type.id !== UserTypes.Student
                  )
                )}
              />
            </div>
            <a
              href="javascript:void(0)"
              className="btn btn-primary"
              data-bs-toggle="modal"
              data-bs-target="#addnewbuttons"
              onClick={handleCreateOpen}
            >
              <img src="/assets/images/icon/plus.svg" alt="" className="me-2" />
              Add New
            </a>
          </div>
        </div>
        <ul className="d-flex grid-3 gap-3 flex-wrap mt-28">
          {isLoading ? (
            <LoaderSpinner />
          ) : reportsData && reportsData.length > 0 ? (
            reportsData.map((report: IReports) => {
              return (
                <li
                  className="admin-card"
                  style={{
                    pointerEvents: !report.isActive ? "none" : "auto",
                    opacity: !report.isActive ? 0.5 : 1,
                  }}
                >
                  <div className="top">
                    <div className="btn-flex">
                      <button
                        className="btn-edit"
                        onClick={() => editItem(report.id ?? 0)}
                      >
                        <img src="/assets/images/icon/edit-wh.svg" alt="" />
                      </button>
                      <button
                        className="btn-delete"
                        onClick={() => deleteItem(report.id ?? 0)}
                      >
                        <img src="/assets/images/icon/trash-wh.svg" alt="" />
                      </button>
                    </div>
                  </div>
                  <a href={report.url} target="_blank">
                    <div className="btm">
                      <div className="img">
                        <img
                          src={report.icon ? baseURL + report.icon : ""}
                          alt=""
                        />
                      </div>
                      <h2>{report.name}</h2>
                      <p>{report.description.slice(0, 30)}</p>
                    </div>
                  </a>
                </li>
              );
            })
          ) : (
            <p>No Records Found</p>
          )}
        </ul>
      </div>

      <ReactModal
        isOpen={showCreate}
        onRequestClose={handleCreateClose}
        className="react-modal-content"
        overlayClassName="react-modal-overlay"
        shouldCloseOnOverlayClick={false}
      >
        <ReportCreate
          setShowCreate={handleCreateClose}
          getAllReports={() => getAllReports()}
        />
      </ReactModal>

      {isEditLoading ? (
        <LoaderSpinner />
      ) : (
        <ReactModal
          isOpen={showEdit}
          onRequestClose={handleEditClose}
          className="react-modal-content"
          overlayClassName="react-modal-overlay"
          shouldCloseOnOverlayClick={false}
        >
          <ReportEdit
            setShowEdit={handleEditClose}
            getAllReports={() => getAllReports()}
            report={report}
          />
        </ReactModal>
      )}

      <SweetAlert
        show={showAlert}
        success={false}
        type={alertType}
        title={alertTitle}
        onConfirm={() => onConfirm()}
        showCancel={isDelete}
        onCancel={() => {
          setShowAlert(false);
          setIsDelete(false);
        }}
        cancelBtnText={"No"}
        confirmBtnText={isDelete ? "Yes" : "Ok"}
      />
    </>
  );
};

const mapDispatchToProps = {
  getReports: () => getReports(),
  getReport: (id: number) => getReport(id),
  deleteReport: (id: number, callBack: Function) => deleteReport(id, callBack),
  getUserTypes: () => getUserTypes(),
};

function mapStateToProps(state: any) {
  return {
    reports: state.report.reports,
    report: state.report.report,
    userTypes: state.common.userTypes,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportIndex);
